<div>
  <idp-login
    (closeLoginToolTipPopup)="closeLoginTooltip()"
    (closeSignupToolTipPopup)="closeSignUpTooltip()"
    (closeAccountRecoveryPopup)="closeAccountRecoveryTooltip()"
    (accountRecoveryLinkClick)="trackAccountRecoveryAddRecovery()"
    (toggleLoginModal)="toggleModal()"
    (openFlyout)="openFlyout()"
    (openFlyoutTracking)="onHeaderFlyoutTracking($event)"
    (analyticsEvent)="analyticsEventTracking($event)"
    [signupLoginContent]="
      (loginFacadeService.signupLoginContent$ | ngrxPush) ||
      emptySignupLoginContent
    "
    [loggedInDetails]="
      (loginFacadeService.loggedInDetails$ | ngrxPush) || emptyLoggedInDetails
    "
    [isLoggedIn]="(loginFacadeService.isLoggedIn$ | ngrxPush) || false"
    [isWarmState]="(loginFacadeService.isWarmState$ | ngrxPush) || false"
    [isReady]="(loginFacadeService.isReady$ | ngrxPush) || false"
    [flyoutToggle]="(flyoutToggle$ | ngrxPush) || false"
    [toolTipToggles]="
      (loginFacadeService.toolTipToggle$ | ngrxPush) || emptyToolTipToggles
    "
    [shopHeader]="shopHeader"
    [isMobile]="(isMobileAndTabletDevice$ | ngrxPush) || false"
  ></idp-login>

  <div *ngIf="flyoutToggle$ | ngrxPush" (keydown.escape)="close()">
    <idp-flyout-logged-in
      (closeEvent)="close()"
      [isAlertAdvisory]="isAlertAdvisory"
    ></idp-flyout-logged-in>
  </div>
</div>
<idp-session-time-out-wrapper
  *ngIf="loginFacadeService.showSessionTimeoutModal"
  (keepLoggedIn)="loginFacadeService.refreshSessionOnExtend()"
  [sessionTimeOutModelContent]="
    (loginFacadeService.sessionTimeOutContent$ | ngrxPush) ||
    emptySessionTimeout
  "
></idp-session-time-out-wrapper>

<div *ngIf="flyoutToggle$ | ngrxPush" (click)="close()"></div>
